<template>
  <div class="content">
    <h3>Gestion des Campagnes Manivox</h3>

    <!-- Form Section -->
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">{{ isEditing ? 'Modifier la campagne' : 'Ajouter une nouvelle campagne' }}</h4>
      </div>
      <div class="card-body">
        <form @submit.prevent="submitForm">
          <div class="row">
            <div class="col-md-6">
              <base-input>
                <label>Tag</label>
                <el-input
                  v-model="formData.tag"
                  placeholder="Entrez le tag de la campagne"
                  required
                ></el-input>
              </base-input>
            </div>
            <div class="col-md-6">
              <base-input>
                <label>Campagne Manivox *</label>
                <el-input
                  v-model="formData.manivox_campaign"
                  placeholder="Entrez le nom de la campagne"
                  required
                ></el-input>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <base-input>
                <label>TM</label>
                <el-input
                  v-model="formData.tm"
                  placeholder="Entrez le TM (optionnel)"
                ></el-input>
              </base-input>
            </div>
            <div class="col-md-6">
              <base-input>
                <label>Compté comme lead après X secondes</label>
                <el-input
                  v-model="formData.counted_after"
                  type="number"
                  placeholder="Compté comme lead après X secondes"
                  min="0"
                ></el-input>
              </base-input>
            </div>
            <div class="col-md-6">
              <base-input>
                <label>Alerte E-mail</label>
                <el-input
                  v-model="formData.email_alert"
                  type="text"
                  placeholder="Vous pouvez entrer plusieurs e-mails en les séparant par un ;"
                ></el-input>
              </base-input>

            </div>    <div class="col-md-6">
              <base-input>
                <label>Description</label>
                <el-input
                  v-model="formData.description"
                  type="textarea"
                  placeholder="description"
                ></el-input>
              </base-input>

            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <base-button
                v-if="isEditing"
                type="secondary"
                @click="cancelEdit"
                class="mr-2"
              >Annuler
              </base-button>
              <base-button
                type="secondary"
                native-type="submit"
                :loading="submitting"
              >
                {{ isEditing ? 'Modifier' : 'Ajouter' }}
              </base-button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Table Section -->
    <card>
      <div class="card-header">
        <h4 class="card-title">Liste des Campagnes</h4>
        <div class="row">
          <div class="col-xl-1 col-sm-6">
            <base-input>
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Par page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-xl-8 col-sm-6">
            <label style="margin-top: 10px; font-size: 0.75rem">Lignes par page</label>
          </div>
          <base-input class="col-xl-3 col-sm-6">
            <el-input
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Recherche"
              v-model="searchQuery"
            ></el-input>
          </base-input>
        </div>
      </div>

      <el-table
        :data="paginatedCampaignsList"
        v-loading="loading"
        :row-class-name="getRowClassName"
        class="customtable"
        style="width: 100%;"
      >


        <!-- Tag Column -->
        <el-table-column prop="tag" label="Tag" min-width="200" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.tag" :open-delay="300" placement="top">
              <span :class="getTextClass(row.old_record)">{{ row.tag }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Manivox Campaign Column -->
        <el-table-column prop="manivox_campaign" label="Campagne Manivox" min-width="180" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.manivox_campaign" :open-delay="300" placement="top">
              <span :class="getTextClass(row.old_record)">{{ row.manivox_campaign }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- TM Column -->
        <el-table-column prop="tm" label="TM" width="120" sortable>
          <template #default="{ row }">
            <span :class="getTextClass(row.old_record)">{{ row.tm || '-' }}</span>
          </template>
        </el-table-column>

        <!-- Calls Column -->
        <el-table-column prop="calls" label="Appels" width="100" sortable>
          <template #default="{ row }">
            <span :class="getTextClass(row.old_record)">{{ row.calls || 0 }}</span>
          </template>
        </el-table-column>

        <!-- Status Column -->
        <el-table-column prop="old_record" label="Statut" width="120" sortable>
          <template #default="{ row }">
            <span class="status-badge" :class="getStatusClass(row.old_record)">
              {{ row.old_record === 1 ? 'Inactif' : 'Actif ' }}
            </span>
          </template>
        </el-table-column>

        <!-- Created At Column -->
        <el-table-column prop="created_at" label="Créé le" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="new Date(row.created_at).toLocaleString()" :open-delay="300" placement="top">
              <span :class="getTextClass(row.old_record)">{{ formatDate(row.created_at) }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Updated At Column -->
        <el-table-column prop="updated_at" label="Modifié le" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="new Date(row.updated_at).toLocaleString()" :open-delay="300" placement="top">
              <span :class="getTextClass(row.old_record)">{{ formatDate(row.updated_at) }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Updated At Column -->
        <el-table-column prop="counted_after" label="TIMING" width="150" sortable>
          <template #default="{ row }">
               <span :class="getTextClass(row.old_record)">{{(row.counted_after) }}s</span>
           </template>
        </el-table-column>
        <!-- Updated At Column -->
        <el-table-column prop="description" label="description" width="150" sortable>
          <template #default="{ row }">
               <span :class="getTextClass(row.old_record)">{{(row.description) }}s</span>
           </template>
        </el-table-column>

        <!-- Actions Column -->
        <el-table-column label="Actions" width="120" align="center">
          <template #default="{ row }">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="editCampaign(row)"
              circle
            ></el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div>
          <p class="card-category">
            Affichage de {{ from + 1 }} à {{ to }} sur {{ total }} entrées
          </p>
        </div>
        <base-pagination
          type="warning"
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import axios from "axios";
import { Table, TableColumn, Select, Option, Input, Button, MessageBox } from "element-ui";
import { BaseButton, BasePagination } from "src/components";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button,
    BaseButton,
    BasePagination,
  },
  data() {
    return {
      campaignsList: [],
      loading: false,
      submitting: false,
      isEditing: false,
      editingId: null,
      formData: {
        tag: '',
        manivox_campaign: '',
        tm: '',
        counted_after: '',
        email_alert: '',
        description: '',
        calls: 0
      },
      searchQuery: "",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [25, 50, 100, 250],
      },
    };
  },
  computed: {
    filteredCampaignsList() {
      if (!this.searchQuery) return this.campaignsList;
      return this.campaignsList.filter((item) =>
        JSON.stringify(item).toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedCampaignsList() {
      const start = this.from;
      const end = this.to;
      return this.filteredCampaignsList.slice(start, end);
    },
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return Math.min(this.pagination.currentPage * this.pagination.perPage, this.total);
    },
    total() {
      return this.filteredCampaignsList.length;
    },
  },
  methods: {
    async fetchCampaignsList() {
      this.loading = true;
      let accessToken = localStorage.getItem("token_jwt");
      const apiUrl = "https://apimyaffil.wee-do-it.net/api/manivox/list_tags";

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });

        // Handle the API response structure you provided
        if (response.data.response.result && Array.isArray(response.data.response.result)) {

          this.campaignsList = response.data.response.result;
        } else {
          this.campaignsList = response.data.result || [];
        }
      } catch (error) {
        console.error("Error fetching campaigns list:", error);
        this.$notify({
          type: "danger",
          message: "Échec de la récupération des données. Veuillez réessayer.",
        });
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.submitting = true;
      let accessToken = localStorage.getItem("token_jwt");

      // Use the correct API endpoints
      const apiUrl = this.isEditing
        ? `https://apimyaffil.wee-do-it.net/api/manivox/update_tag/${this.editingId}`
        : "https://apimyaffil.wee-do-it.net/api/manivox/add_tag";

      try {
        const method = this.isEditing ? 'post' : 'post';
        const response = await axios[method](apiUrl, this.formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        });

        this.$notify({
          type: "success",
          message: this.isEditing ? "Campagne modifiée avec succès!" : "Campagne ajoutée avec succès!",
        });

        this.resetForm();
        this.fetchCampaignsList();
      } catch (error) {
        console.error("Error submitting form:", error);

        // Handle validation errors or other server errors
        let errorMessage = "Erreur lors de la soumission. Veuillez réessayer.";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        this.$notify({
          type: "danger",
          message: errorMessage,
        });
      } finally {
        this.submitting = false;
      }
    },

    editCampaign(campaign) {
      this.isEditing = true;
      this.editingId = campaign.id;
      this.formData = {
        tag: campaign.tag || '',
        manivox_campaign: campaign.manivox_campaign || '',
        counted_after: campaign.counted_after || '',
        email_alert: campaign.email_alert || '',
        description: campaign.description || '',
        tm: campaign.tm || '',
        calls: campaign.calls || 0
      };

      // Scroll to form
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },

    cancelEdit() {
      this.resetForm();
    },

    resetForm() {
      this.isEditing = false;
      this.editingId = null;
      this.formData = {
        tag: '',
        manivox_campaign: '',
        counted_after: '',
        email_alert: '',
        description: '',
        tm: '',
        calls: 0
      };
    },

    async deleteCampaign(campaign) {
      try {
        await MessageBox.confirm(
          'Êtes-vous sûr de vouloir supprimer cette campagne?',
          'Confirmer la suppression',
          {
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
            type: 'warning'
          }
        );

        let accessToken = localStorage.getItem("token_jwt");
        const apiUrl = `https://apimyaffil.wee-do-it.net/api/manivox/delete_tag/${campaign.id}`;

        await axios.delete(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });

        this.$notify({
          type: "success",
          message: "Campagne supprimée avec succès!",
        });

        this.fetchCampaignsList();
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error("Error deleting campaign:", error);
        this.$notify({
          type: "danger",
          message: "Erreur lors de la suppression. Veuillez réessayer.",
        });
      }
    },

    getRowClassName({ row }) {
      // Remove row background styling, keep only for potential future use
      return '';
    },

    getTextClass(oldRecord) {
      return oldRecord === 1 ? 'text-old-record' : 'text-new-record';
    },

    getStatusClass(oldRecord) {
      return oldRecord === 1 ? 'status-old' : 'status-new';
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  mounted() {
    this.fetchCampaignsList();
  },
};
</script>

<style scoped>
.content {
  padding: 20px;
}

.customtable {
  word-break: break-word;
}

/* Text color styling based on old_record status */
.text-old-record {
  color: #d32f2f !important;
  font-weight: 500;
}

.text-new-record {
  color: #388e3c !important;
  font-weight: 500;
}

/* Status badge styling */
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: bold;
}

.status-old {
  background-color: #ffcdd2;
  color: #c62828;
}

.status-new {
  background-color: #c8e6c9;
  color: #2e7d32;
}

/* Form styling */
.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.card-title {
  margin-bottom: 0;
  color: #495057;
}

/* Button styling */
.el-button.is-circle {
  width: 32px;
  height: 32px;
  padding: 0;
  margin: 0 2px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .customtable {
    font-size: 0.875rem;
  }

  .el-table__body-wrapper {
    overflow-x: auto;
  }
}
</style>
